import { render, staticRenderFns } from "./OldMatterAltList.vue?vue&type=template&id=01eb6ba6&scoped=true"
import script from "./OldMatterAltList.vue?vue&type=script&lang=js"
export * from "./OldMatterAltList.vue?vue&type=script&lang=js"
import style0 from "./OldMatterAltList.vue?vue&type=style&index=0&id=01eb6ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb6ba6",
  null
  
)

export default component.exports